import { firestore } from './FirebaseConfig';


// Function to retrieve the likes count
export const getLikesCount = (slug, callBackFunction) => {
  firestore
    .collection(`teamPosts`)
    .doc(slug)
    .get()
    .then((doc) => {
      if (doc.exists) {
        const Data = doc.data();
        const likesData = Data.likes;
        const likesCount = Object.keys(likesData).length;
        callBackFunction(likesCount);
      }
    })
    .catch((err) => {
      console.error(err);
    });
};

// Function to retrieve the comments

export const getComments = async (slug, callBackFunction) => {
  firestore
      .collection('teamPosts')
      .doc(slug)
      .get()
      .then((doc) => {
        if (doc.exists) {
          const parentDoc = doc.data();
          const commentsData = parentDoc.comments || [];
          const commentCount = Object.keys(commentsData).length || 0;
          const sortedComments = commentsData.sort((a, b) => a.date - b.date); 
          const processedComments = sortedComments
          .map((item) => (
            <div
              key={item.date}
              className="border dark:border-gray-500 rounded p-5 w-full mt-5 flex flex-col"
            >
              <span className="text-lg text-gray-500 dark:text-gray-300 font-medium">
                {item.displayName}
              </span>
              <span className="mt-3 text-md text-gray-500 dark:text-gray-300">
                {item.content}
              </span>
            </div>
          ))
          callBackFunction(commentCount, processedComments);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };
  
  
/*
export const getComments = (slug, callBackFunction) => {
    firestore
      .collection('teamPosts')
      .doc(slug)
      .get()
      .then((doc) => {
        if (doc.exists) {
          const postData = doc.data();
          const commentsData = postData.comments || []; // Handle case where commentsData is undefined
          const sortedComments = commentsData.sort((a, b) => a.date - b.date); // Sort comments by date in ascending order
          callBackFunction(sortedComments);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };
  

  try {
    const postCommentsRef = firestore.collection('teamPosts').doc(id).collection('comments');
    const snapshot = await postCommentsRef.orderBy('date', 'asc').get();

    const commentsData = snapshot.docs.map((doc) => {
      const commentData = doc.data();
      return {
        commentId: doc.id, // Add a unique commentId
        ...commentData,
      };
    });

    setComments(commentsData);
  } catch (error) {
    console.error('Error fetching post comments:', error);
  }
};
  
  */
